export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const truncate = (str: string, limit: number) => {
  return str.length > limit ? `${str.slice(0, limit)}...` : str
}

export const truncateDescription = (str: string | undefined) => {
  return truncate(str || '', 140)
}

export const truncateForCart = (str: string) => {
  return truncate(str, 25)
}
